/* eslint-disable */
const utils = {

  centerAssetToScreen(target, screen = null) {
    if (!screen) {
      console.warn('-no screen options for ', target.name);
      return;
    }
    
    target.scale.set(screen.scale.y, screen.scale.y);
    target.x = (screen.w - (target.texture.baseTexture.width * target.scale.y)) * .5;
    target.y = (screen.h - (target.texture.baseTexture.height * target.scale.y)) * .5;

    if(screen.offset) {
      target.x += screen.offset.x * screen.w;
      target.y += screen.offset.y * screen.h;
    }
  },
  
  toFullscreen(target, screen = null) {
    if(!screen) {
      console.warn('*no screen options for ', target.name);
      return;
    }

    const ratio = (target.name !== 'carContainer') ? target.texture.baseTexture.height / target.texture.baseTexture.width : 1920 / 1080;
     
    if (screen.keepRatio) {
      target.width = screen.w;
      target.height = target.width * ratio;
      target.x = (screen.w - target.width) * .5;
      target.y = (screen.h - 46 - target.height) * .5;

      if (screen.toTop) target.y = 0;
    }
    else{
      target.width = screen.w;
      target.height = screen.h - 46;
      target.x = target.y = 0;
    }
  },

  randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },

  degreeToRadians(degrees){
    var pi = Math.PI;
    return degrees * (pi / 180);
  }
}

export default utils;
